(() => {
  function init(root = document) {
    root.querySelectorAll('[data-eco-solutions]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const tabs = [...section.querySelectorAll('[data-eco-tab]')];
      const panels = [...section.querySelectorAll('[data-eco-panel]')];
      section.querySelector('.eco-tabs').setAttribute('role', 'tablist');
      function activate(index, focus = false) {
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index; });
        if (focus) tabs[index].focus();
      }
      tabs.forEach((tab, i) => {
        tab.id = panels[i].id + '-tab'; tab.setAttribute('role', 'tab'); tab.setAttribute('aria-controls', panels[i].id);
        panels[i].setAttribute('role', 'tabpanel'); panels[i].setAttribute('aria-labelledby', tab.id); panels[i].tabIndex = 0;
        tab.addEventListener('click', event => { event.preventDefault(); activate(i); });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(next, true); }
        });
      });
      activate(0);
    });
  }
  function openLayer() { const id = location.hash.slice(1); const layer = document.getElementById(id); if (layer?.classList.contains('eco-layer')) layer.open = true; }
  init(); openLayer(); window.addEventListener('hashchange', openLayer);
  document.addEventListener('shopify:section:load', () => init());
})();
